<hr class="my-3" />
<h4 class="mb-3">Dokumenty</h4>
<form [formGroup]="form">
	<div>
		@for (documentControl of documentsForm.controls; track documentControl; let i = $index) {
			<div class="d-flex flex-row flex-wrap gap-2 align-items-start mb-2" [formGroup]="documentControl">
				<mat-form-field appearance="outline">
					<mat-label>Typ dokumentu</mat-label>
					<mat-select formControlName="kind" placeholder="Wybierz typ">
						@for (kind of documentKinds(); track kind.id) {
							<mat-option [value]="kind.id">
								{{ kind.name }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Numer dokumentu</mat-label>
					<input type="text" matInput formControlName="number" />
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Data ważności</mat-label>
					<input matInput [matDatepicker]="docDatepicker" formControlName="expirationDate" />
					<mat-datepicker-toggle matSuffix [for]="docDatepicker"></mat-datepicker-toggle>
					<mat-datepicker #docDatepicker>
						<mat-datepicker-actions>
							<button mat-button matDatepickerCancel>Anuluj</button>
							<button mat-raised-button color="primary" matDatepickerApply>Zatwierdź</button>
						</mat-datepicker-actions>
					</mat-datepicker>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Kraj wydania</mat-label>
					<mat-select formControlName="countryOfIssue" placeholder="Wybierz kraj">
						@for (c of countries(); track c.id) {
							<mat-option [value]="c.id">{{ c.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<button mat-icon-button type="button" (click)="removeDocument(i)" aria-label="Usuń dokument">
					<i class="fa-solid fa-trash-can"></i>
				</button>
			</div>
		}
		<button
			mat-raised-button
			color="primary"
			type="button"
			(click)="addDocument()"
			[disabled]="isAddDocumentDisabled()"
		>
			Dodaj dokument
			<i class="fa-solid fa-circle-plus ms-2"></i>
		</button>
	</div>
</form>
